import { render, staticRenderFns } from "./HoldingGeneralInfo.vue?vue&type=template&id=4d3427a4&scoped=true&"
import script from "./HoldingGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./HoldingGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./HoldingGeneralInfo.vue?vue&type=style&index=0&id=4d3427a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3427a4",
  null
  
)

export default component.exports